// utils/response.ts

type SuccessResponse<T = any> = {
  success: true;
  message?: string;
} & T;

type ErrorResponse<T = any> = {
  success: false;
  message?: string;
} & T;

export const response = {
  success: <T extends object>(data: T, message?: string): SuccessResponse<T> => {
    return {
      success: true,
      ...(message ? { message } : {}),
      ...data,
    };
  },

  error: <T extends object>(data: T, message?: string): ErrorResponse<T> => {
    return {
      success: false,
      ...(message ? { message } : {}),
      ...data,
    };
  },
};
